import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `EntryStyleRoot`,
  label: `EntryStyleLabel`,
  value: `EntryStyleValue`,
  action: `EntryStyleAction`,
  list: `EntryStyleList`,
  listentry: `EntryStyleListEntry`
};

export function useEntryStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          overflow: `hidden`,
          width: `100%`
        }
      ],
      label: [
        classNames.label,
        {
          width: `15%`
        }
      ],
      value: [
        classNames.value,
        {
          lineHeight: `32px`,
          overflow: `hidden`
        }
      ],
      action: [classNames.action, {}],
      list: [
        classNames.list,
        {
          margin: 0,
          padding: 0
        }
      ],
      listentry: [classNames.listentry, {}]
    }),
    []
  );
}
